export default "__VITE_ASSET__042338df__"